import { IOrganization } from '../../../interfaces/graph-types';
import { OrganizationService } from './../../../services/organization.service';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export enum STATE {
  ACCCOUNTS = 'accounts',
  PERMISSIONS = 'permissions',
  INVITE = 'invite',
}

@Component({
  selector: 'team-permissions',
  template: require('./team-permissions.component.pug'),
  styles: [require('./team-permissions.component.css').toString()],
})
export class TeamPermissionsComponent implements OnInit {
  state: STATE;
  org_id: string;
  loading = true;
  organization: IOrganization;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private service: OrganizationService,
  ) {
    this.state = STATE.ACCCOUNTS;
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.service.getAccountList(this.org_id).subscribe(res => {
      this.loading = false;
      this.organization = res;
    });
  }

  // -------------------------------------------------------------------
  setState(state: STATE) {
    this.state = state;
  }
}

console.log('permissions');
